import { useCallback, useMemo } from 'react';

import { track, TrackingEventName } from '@heidi/analytics/events';

/**
 * Analytics for the "Enable Session Merge" onboarding promo (APP-8093).
 * Snowplow-first, `amplitude: false`. All three events are property-less (the
 * Iglu schemas declare `additionalProperties: false`), so the funnel joins to
 * the sessions/user tables in the warehouse rather than carrying context here.
 *
 * - `trackViewed` — the promo sheet is shown.
 * - `trackAccepted` — "Try now" tapped (auto-merge enabled).
 * - `trackDismissed` — sheet dismissed without enabling.
 */
export function useSessionMergeOnboardingAnalytics() {
  const trackViewed = useCallback(() => {
    track({
      event_name: TrackingEventName.SessionMergeOnboardingViewed,
      props: {},
      options: { amplitude: false },
    });
  }, []);

  const trackAccepted = useCallback(() => {
    track({
      event_name: TrackingEventName.SessionMergeOnboardingAccepted,
      props: {},
      options: { amplitude: false },
    });
  }, []);

  const trackDismissed = useCallback(() => {
    track({
      event_name: TrackingEventName.SessionMergeOnboardingDismissed,
      props: {},
      options: { amplitude: false },
    });
  }, []);

  return useMemo(
    () => ({ trackViewed, trackAccepted, trackDismissed }),
    [trackViewed, trackAccepted, trackDismissed]
  );
}
